<template>
  <div>
    <slot name="mobile-navbar">
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="e296a164-57eb-5ae3-cb7a-7c29806a8e27"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
        v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
      >
        <div class="navbar1_container">
          <router-link
            to="/client-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
            />
          </router-link>
          <div
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
            @click="showNav"
          >
            <div class="menu-icon1">
              <div
                class="menu-icon1_line-top"
                :style="[
                  bar
                    ? {
                        transform:
                          'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg) transform-style: preserve-3d'
                      }
                    : {}
                ]"
              ></div>
              <div
                class="menu-icon1_line-middle"
                :style="[bar ? { width: '24px', height: '2px' } : {}]"
              >
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div
                class="menu-icon1_line-bottom"
                :style="[
                  bar
                    ? {
                        transform:
                          'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg) transform-style: preserve-3d'
                      }
                    : {}
                ]"
              ></div>
            </div>
          </div>
        </div>
        <!--        w-nav-overlay-0 id name-->
        <div
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          v-if="cross"
        >
          <nav
            role="navigation"
            id="nav"
            class="navbar1_menu w-nav-menu"
            :style="[
              cross ? { transform: 'translateX(0px) translateY(0px)' } : {}
            ]"
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="e296a164-57eb-5ae3-cb7a-7c29806a8e2d"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="../../assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <div
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="profile-picture"
                    >
                      <img
                        :src="customerInfo.customerDisplayPicture"
                        class="image-profile-pic"
                      />
                    </div>
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfile" class="link-18">View profile</a>
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/client-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/customer-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/customer-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>
                  <router-link
                    to="/customer-classes"
                    class="link-block-4 classes w-inline-block"
                  >
                    <div class="text-block-27">My Classes</div>
                  </router-link>
                  <router-link
                    to="/customer-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/customer-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/customer-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/become-a-professional"
                    class="link-block-4 professional w-inline-block"
                  >
                    <div class="text-block-27">Become a professional</div>
                  </router-link>

                  <router-link
                    to="/discover"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/customer-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <a
                    class="link-block-4 log-out w-inline-block"
                    @click="logout"
                  >
                    <div class="text-block-27">Log out</div>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
        v-else
      >
        <div class="navbar1_container">
          <router-link
            to="/professional-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></router-link>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <a
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                href="#"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </a>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <img
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="image-profile-pic"
                      style="border-radius:50%;"
                      :src="customerInfo.customerDisplayPicture"
                    />
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a class="link-18" @click="goToProfProfile"
                        >View profile</a
                      >
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>

                  <router-link
                    to="/professional-classes"
                    class="link-block-4 classes w-inline-block"
                  >
                    <div class="text-block-27">My Classes</div>
                  </router-link>

                  <router-link
                    to="/professional-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/professional-availability"
                    class="link-block-4 availability w-inline-block"
                  >
                    <div class="text-block-27">Available slots</div>
                  </router-link>
                  <router-link
                    to="/wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/professional-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/discover"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <router-link
                    to="/login"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
    </slot>
    <div class="app wf-section">
      <slot name="app-navbar">
        <AppNavBar
          v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
        />
        <ProfessionalAppNavBar v-else />
      </slot>
      <div class="app-container hero">
        <div class="main-app-wrapper dashboard">
          <slot name="sidebar">
            <TimeslotSidebar />
          </slot>
          <slot />
          <slot name="right-side-nav">
            <RightSideMenu
              v-if="
                userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId
              "
            />
            <div v-else></div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/normalize.css";
import "@/assets/css/webflow.css";
import TimeslotSidebar from "@/views/timeslot/TimeslotSidebar";
import RightSideMenu from "@/views/timeslot/RightSideMenu";
import AppNavBar from "@/components/navbar/AppNavBar";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import Router from "@/router/router";
export default {
  name: "TimeslotDashboardLayout",
  data() {
    return {
      bar: true,
      cross: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionals: state => state.professional.professionals,
      professionalId: state => state.professional.professionalId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    })
  },
  components: {
    ProfessionalAppNavBar,
    TimeslotSidebar,
    RightSideMenu,
    AppNavBar
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    goToProfProfile() {
      if ("professional" in this.userInfo) {
        RouterUtils.changeRouteUrlTo(
          `/professionals/${this.userInfo.professional.professionalId}`
        );
      } else {
        RouterUtils.changeRouteUrlTo(
          `/professionals/${this.this.customerToProfessionalId}`
        );
      }
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/clients/${this.userInfo.customerId}`);
    }
  }
};
</script>

<style scoped src="../../assets/css/timeslot-dev.webflow.css"></style>
